export default import.meta.ROLLUP_FILE_URL_tR0r3ofv2cZ9F5A8eSBYMg